<cc-form-container [isLoading]="isLoading$ | async">
  <ng-container form-buttons>
    <cc-delete-action-button
      (onClick)="delete()"
      [disabled]="isLoading$ | async"
      tooltip="common.DELETE"
      [icon]="faTimes"
      displayText="common.DELETE"
    >
    </cc-delete-action-button>

    <cc-save-action-button
      form-buttons
      (onClick)="submit()"
      class="button-align"
    ></cc-save-action-button>
  </ng-container>

  <form
    [formGroup]="formGroup"
    form-content
    [patchFormGroupWithEmitValues]="value$ | async"
  >
    <div formContainerFormRow>
      <mat-form-field>
        <mat-label>{{ 'hkn-identifier.YEAR' | transloco }}</mat-label>
        <input formControlName="year" matInput type="number" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'hkn-identifier.IDENTIFIER' | transloco }}</mat-label>
        <input formControlName="identifier" matInput />
      </mat-form-field>
    </div>
    <div formContainerFormRow>
      <mat-form-field>
        <mat-label>{{ 'hkn-identifier.HKN_TYPE' | transloco }}</mat-label>
        <mat-select formControlName="hknTypeId">
          @for (item of hknTypes$ | async; track item.id) {
            <mat-option [value]="item.id">{{ item.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div formContainerFormRow>
      <mat-form-field>
        <mat-label>{{ 'hkn-identifier.SUPPLIER' | transloco }}</mat-label>
        <mat-select formControlName="supplierId">
          @for (item of suppliers$ | async; track item.id) {
            <mat-option [value]="item.id">{{ item.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'hkn-identifier.DELIVERY_AREA' | transloco }}</mat-label>
        <mat-select formControlName="deliveryAreaId">
          @for (item of deliveryAreas$ | async; track item.id) {
            <mat-option [value]="item.id">{{ item.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</cc-form-container>
